const SET_TEAM_LEADER_DATA = 'SET_TEAM_LEADER_DATA'

const state = {
  teamLeaderData: {},
}

const mutations = {
  [SET_TEAM_LEADER_DATA]: (state, value) => {
    state.teamLeaderData = value
  },
}

const actions = {
  setTeamLeaderData({ commit }, val) {
    commit(SET_TEAM_LEADER_DATA, val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
